import dateFormat from 'date-fns/format'
import isThisWeek from 'date-fns/isThisWeek'

export const getTime = (timestamp: number) => {
  const date = new Date(timestamp * 1000)

  return dateFormat(date, 'H:MM')
}

export const getRelativeDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000)

  const dayStart = new Date()
  dayStart.setHours(0, 0, 0, 0)

  if (date > dayStart) {
    return dateFormat(date, 'H:MM')
  }

  if (isThisWeek(date)) {
    return dateFormat(date, 'EEE')
  }

  return dateFormat(date, 'dd.MM.yyyy')
}
